/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Play_How_TitleInputs */

const bn_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কিভাবে খেলতে হয়`)
};

const de_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie man spielt`)
};

const el_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πώς να παίξετε`)
};

const en_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to play`)
};

const es_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`como jugar`)
};

const fr_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment jouer`)
};

const hi_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैसे खेलने के लिए`)
};

const hu_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hogyan kell játszani`)
};

const id_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara bermain`)
};

const it_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come giocare`)
};

const ja_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊び方`)
};

const ko_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플레이 방법`)
};

const nl_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe te spelen`)
};

const pl_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak grać`)
};

const pt_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como jogar`)
};

const ru_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как играть`)
};

const sv_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hur man spelar`)
};

const tr_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl oynanır`)
};

const uk_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Як грати`)
};

const vi_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cách chơi`)
};

const zh_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`怎么玩`)
};

const zh_hant_how_to_play_how_title = /** @type {(inputs: How_To_Play_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`怎麼玩`)
};

/**
* | output |
* | --- |
* | "How to play" |
*
* @param {How_To_Play_How_TitleInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const how_to_play_how_title = /** @type {((inputs?: How_To_Play_How_TitleInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Play_How_TitleInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_how_to_play_how_title(inputs)
	if (locale === "de") return de_how_to_play_how_title(inputs)
	if (locale === "el") return el_how_to_play_how_title(inputs)
	if (locale === "en") return en_how_to_play_how_title(inputs)
	if (locale === "es") return es_how_to_play_how_title(inputs)
	if (locale === "fr") return fr_how_to_play_how_title(inputs)
	if (locale === "hi") return hi_how_to_play_how_title(inputs)
	if (locale === "hu") return hu_how_to_play_how_title(inputs)
	if (locale === "id") return id_how_to_play_how_title(inputs)
	if (locale === "it") return it_how_to_play_how_title(inputs)
	if (locale === "ja") return ja_how_to_play_how_title(inputs)
	if (locale === "ko") return ko_how_to_play_how_title(inputs)
	if (locale === "nl") return nl_how_to_play_how_title(inputs)
	if (locale === "pl") return pl_how_to_play_how_title(inputs)
	if (locale === "pt") return pt_how_to_play_how_title(inputs)
	if (locale === "ru") return ru_how_to_play_how_title(inputs)
	if (locale === "sv") return sv_how_to_play_how_title(inputs)
	if (locale === "tr") return tr_how_to_play_how_title(inputs)
	if (locale === "uk") return uk_how_to_play_how_title(inputs)
	if (locale === "vi") return vi_how_to_play_how_title(inputs)
	if (locale === "zh") return zh_how_to_play_how_title(inputs)
	return zh_hant_how_to_play_how_title(inputs)
});